import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["contentType", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import ContentGroupTabs from './ContentGroupTabs';
import { getSectionsData } from './helpers';
const ContentGroup = _ref => {
  var _children$props;
  let {
      contentType,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const groupSections = children === null || children === void 0 ? void 0 : (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.children[1];
  if (!groupSections || !groupSections.length) return '';
  if (contentType !== 'tab' && contentType !== 'sidepanel') return '';
  const sectionsData = getSectionsData(groupSections);
  return /*#__PURE__*/React.createElement(ContentGroupTabs, _extends({
    contentType: contentType,
    groupSections: groupSections,
    sectionsData: sectionsData
  }, props));
};
ContentGroup.propTypes = {
  children: PropTypes.object.isRequired,
  contentType: PropTypes.string.isRequired
};
ContentGroup.defaultProps = {};
export default ContentGroup;
//# sourceMappingURL=ContentGroup.js.map